import 'reflect-metadata';
import { container } from 'tsyringe';
import React, { createContext, useContext } from 'react';
export const InjectionContext = createContext({ container: container });
export const InjectionProvider = (props) => {
    const { container, children } = props;
    return React.createElement(InjectionContext.Provider, { value: { container } }, children);
};
export const useInjection = () => useContext(InjectionContext);
